import { compose, withProps } from 'recompose';
import { routes, searchTileType } from '../../../../constants';
import CpdCategory from './partials/area-of-advice';

export default compose(
  withProps(() => ({
    searchTileType: searchTileType.Event,
    parentName: 'Events',
    parentPath: routes.app.training.eventHome,
    searchLabel: 'Search Events',
  })
  )
)(CpdCategory);


// WEBPACK FOOTER //
// ./src/containers/pages/app/training/event-area-of-advice.js